export default "__VITE_ASSET__DOZcCHoE__"